import * as React from 'react'
import PhotoUploadIcon from '../icons/ui/PhotoUploadIcon'

//Generate Avatar
import Avatar, { ConfigProvider } from 'react-avatar'

interface IProps {
  entityId?: string
  entityId1?: string
  width?: string
  height?: string
  isRounded?: boolean
  name?: string
  name1?: string
  className?: string
}

interface IState {
  onError: boolean
}

class ImageView extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      onError: false
    }
  }

  public render() {
    const { entityId, name, isRounded, className } = this.props
    const width = this.props.width || '96px'
    const height = this.props.height || '96px'
    const fcolor = '#FFFFFF'
    return (
      <div className={`image-view-container ${className || ''}`}>
        {entityId && isRounded && (
          <ConfigProvider colors={['#ACDDDE', '#CAF1DE', '#E1F8DC', '#FEF8DD', '#FFE7C7', '#F7D8BA']}>
            <Avatar
              alt='Logo'
              className='bold-avatar'
              name={name}
              size={'50px'}
              round={true}
              style={{ color: fcolor }}
              maxInitials={2}
              textSizeRatio={5.0}
              src={this.getURL()}
            />
          </ConfigProvider>
        )}
        {entityId && !isRounded && (
          <img
            alt='Logo'
            style={{ maxWidth: height, maxHeight: height, display: 'block' }}
            onError={this.onError}
            src={this.getURL()}
          />
        )}
      </div>
    )
  }

  private onError = () => {
    this.setState({
      onError: true
    })
  }

  private getBucketName = () => {
    return process.env.REACT_APP_ENV === 'production'
      ? process.env.REACT_APP_S3_BUCKET_PROD
      : process.env.REACT_APP_S3_BUCKET_DEV
  }

  private getURL = () => {
    const sha1 = require('sha1')

    return this.state.onError
      ? ''
      : `https://${this.getBucketName()}.s3.amazonaws.com/uploads/${sha1(this.props.entityId)}.png`
  }
}

export default ImageView



// WEBPACK FOOTER //
// ./src/components/ui/ImageView.tsx